import Checkbox from '@pinecast/common/Checkbox';
import type {FieldProps} from '@pinecast/common/forms';
import {useField} from '@pinecast/common/forms';
import type {LocalizedReactNode} from '@pinecast/common/types';

type Props = {
  description?: LocalizedReactNode;
  disabled?: boolean;
  label: LocalizedReactNode;
  disabledIf?: () => boolean;
};

const CheckboxField = (props: FieldProps<Props>) => {
  const {fieldState, fieldApi} = useField(props);
  const {description, disabledIf, disabled, label} = props;
  const forceDisabled = disabledIf?.() ?? false;
  return (
    <Checkbox
      alignInput={description ? 'top' : 'center'}
      checked={!!fieldState.value}
      disabled={disabled || forceDisabled}
      nativeEvents={{
        onBlur: () => {
          fieldApi.setTouched(true);
        },
      }}
      onChange={value => {
        fieldApi.setValue(value);
        fieldApi.setTouched(true);
      }}
      subText={description}
      text={label}
    />
  );
};

export default CheckboxField;
